import React from "react";
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  Platform,
  useWindowDimensions,
} from "react-native";
import Svg, { Circle } from "react-native-svg";
import GlobalStyles from "./StylenColor";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "react-native-responsive-screen";

const CircularProgress = ({ outerValue, innerValue, topic, onLongPress }) => {
  const { width } = useWindowDimensions();
  const isDesktopWeb = Platform.OS === "web" && width > 900;
  const size = isDesktopWeb ? wp("9%") : wp("27.2%");
  const strokeWidth = isDesktopWeb ? wp("0.7%") : wp("1.8%");
  const outerRadius = (size - strokeWidth) / 2;
  const innerRadius = isDesktopWeb ? outerRadius - wp("1.2%") : outerRadius -  wp("3.5%");

  const outerCircumference = 2 * Math.PI * outerRadius;
  const innerCircumference = 2 * Math.PI * innerRadius;

  const getOffset = (value, circumference) =>
    circumference - (value / 100) * circumference;

  const getGradientColor = (value) => {
    if (value < 50) {
      return `rgb(255, ${Math.round((value / 50) * 165)}, 0)`;
    } else {
      return `rgb(${Math.round(255 - ((value - 50) / 50) * 255)}, 165, 0)`;
    }
  };

  const isOuterValid = typeof outerValue === "number" && !isNaN(outerValue);
  const isInnerValid = typeof innerValue === "number" && !isNaN(innerValue);

  return (
    <View style={[styles.circularContainer, isDesktopWeb && { width: "33%" }]}>
      <View
        style={[
          { position: "relative", width: size, height: size },
          isDesktopWeb && { marginBottom: hp("1%") },
        ]}
      >
        <Svg width={size} height={size}>
          {/* Outer Track */}
          <Circle
            cx={size / 2}
            cy={size / 2}
            r={outerRadius}
            stroke="#eff1f0"
            strokeWidth={strokeWidth}
            fill="none"
          />
          {isOuterValid && (
            <Circle
              cx={size / 2}
              cy={size / 2}
              r={outerRadius}
              stroke={getGradientColor(outerValue)}
              strokeWidth={strokeWidth}
              fill="none"
              strokeDasharray={outerCircumference}
              strokeDashoffset={getOffset(outerValue, outerCircumference)}
              strokeLinecap="round"
            />
          )}

          {/* Inner Track */}
          <Circle
            cx={size / 2}
            cy={size / 2}
            r={innerRadius}
            stroke="#eff1f0"
            strokeWidth={strokeWidth}
            fill="none"
          />
          {isInnerValid && (
            <Circle
              cx={size / 2}
              cy={size / 2}
              r={innerRadius}
              stroke={getGradientColor(innerValue)}
              strokeWidth={strokeWidth}
              fill="none"
              strokeDasharray={innerCircumference}
              strokeDashoffset={getOffset(innerValue, innerCircumference)}
              strokeLinecap="round"
            />
          )}
        </Svg>

        {/* Progress Text Centered */}
        <TouchableOpacity
          onLongPress={onLongPress}
          delayLongPress={500}
          style={[
            styles.progressTextContainer,
            { width: size, height: size },
            isDesktopWeb && { alignContent: "center" },
          ]}
        >
          <Text
            style={[
              styles.progressText,
              isDesktopWeb && { fontSize: GlobalStyles.fontSize.xsss - 2 },
            ]}
          >
            {isOuterValid ? `${Math.round(outerValue)}%` : "NE"} |{" "}
            {isInnerValid ? `${Math.round(innerValue)}%` : "NE"}
          </Text>
        </TouchableOpacity>
      </View>

      <View style={styles.topicContainer}>
        <Text
          style={[
            styles.topicText,
            isDesktopWeb && {
              marginTop: 12,
              fontSize: GlobalStyles.fontSize.xs - 2.5,
              marginBottom: hp("2%"),
            },
          ]}
        >
          {topic}
        </Text>
      </View>
    </View>
  );
};
const styles = StyleSheet.create({
  circularContainer: {
    alignItems: "center",
    justifyContent: "space-evenly",
    width: "33%",
    position: "relative",
    alignContent: "space-evenly",
    marginBottom: 13,
  },
  progressTextContainer: {
    position: "absolute",
    // top: 0,
    // left: 0,
    // right: 0,
    // bottom: 0,
    alignItems: "center",
    justifyContent: "center",
  },
  progressText: {
    fontSize: GlobalStyles.fontSize.xsss,
    fontFamily: GlobalStyles.GlobalFont.fontFamily,
  },
  topicContainer: {
    height: hp("6.5%"),
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    marginTop: 2,
    marginBottom: 2,
  },
  topicText: {
    fontSize: GlobalStyles.fontSize.xs,
    fontFamily: GlobalStyles.inpFont.fontFamily,
    textAlign: "center",
    width: "100%",
    flexShrink: 1,
    paddingVertical: 1,
  },
});

export default CircularProgress;
